// @ts-ignore
import axios from 'axios';
const baseUrl='https://api.ch5.zddxdd.com/'
import router from "@/router";
import customConfig from "../../customConfig";
export function getOssInfoApi() {
  return axios({
    url: 'https://api.h5.zddxdd.com/zas/oss',
    method: 'POST'
  })
};
export function uploadApi(data) {
  return axios({
    url: baseUrl+'zbo/oss',
    method: 'POST',
    headers:{
      "Content-type": "multipart/form-data",
    },
    data
  })
};

export function getOpenIdApi (params) {
  return axios({
    url: baseUrl+'zca_wechat/loginRes',
    method: 'GET',
    params
  })
};
export function getUserInfoApi (data) {
  return axios({
    url: baseUrl+'zca_wap/userInfo',
    method: 'POST',
    data
  })
};
export function submitApi (data) {
  return axios({
    url: 'https://api.h5.greege.com.cn/zbu/submit',
    method: 'post',
    data
  })
};


axios.interceptors.response.use((res=>{
  if(res.data.code==1886){
    localStorage.removeItem(customConfig.userInfoName)
    router.replace('/')
    return false
  }
  return res
}))
